import { render } from "./Login.vue?vue&type=template&id=663c1667&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=663c1667&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-663c1667"

export default script